Apt.fn.make('property', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;
		const id = $.context('id');

		priv.id = id;

		priv.context = $.context('context');
		priv.criteria = $.context('criteria');

		priv.initScreen();
		priv.initMedia();
		priv.initAnalytics();
		priv.initTruncate();
		priv.initSeller();
		priv.initData();
		priv.initState();

		LS.util.idle(() => {
			priv.initAds();

			priv.initShare(priv, 'property', {
				target: 'listing',
				label: 'property',
				id: id,
				context: {
					key: priv.context.key,
					source: priv.context.source
				}
			});

			priv.report = Apt.fn.report()
				.init({
					path: 'properties',
					target: 'listings',
					id: id
				});

			priv.initCopy();
			priv.initAgent();
			priv.initRelevant(id);
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		const priv = this.$private;

		if (! priv.id) {
			return;
		}

		if (priv.videos) {
			priv.videos.forEach(video => {
				video.$destroy();
			});

			priv.videos = null;
		}

		LS.util.reset('property', priv, [
			'ads',
			'images',
			'lazyThumbs',
			'map',
			'media',
			'call',
			'message',
			'payment',
			'relevant',
			'report',
			'share',
			'tabs',
			'videoGallery'
		], true);

		priv.truncate.forEach(el => {
			el.$destroy();
		});

		Apt.panel.locked = false;
	}
}, {
	/**
	 * Register responsive element positioning
	 */
	initScreen() {
		const scope = this;

		$.screen.map([
			{
				max: 3,
				callback: () => {
					$$('propertyAd').insertBefore('$accordion');
				}
			},
			{
				max: 3,
				callback: () => {
					$$('propertyMeta').appendTo('$propertyRight');
				}
			},
			{
				max: 3,
				once: true,
				callback: () => {
					scope.initOptions();
				}
			},
			{
				min: 3,
				init: false,
				callback: conf => {
					if (conf.prev < 3 && scope.map) {
						scope.map.minimize();
					}
				}
			},
			{
				min: 4,
				once: true,
				callback: () => {
					scope.initThumbnails();
				}
			},
			{
				min: 4,
				init: false,
				callback: () => {
					$$('propertyAd').prependTo('$propertyRight');
					$$('propertyMeta').appendTo('$propertyLeft');
				}
			}
		], {
			namespace: 'property'
		});
	},

	/**
	 * Initialize the seller contact
	 */
	initSeller() {
		const scope = this;
		const $message = $$('message');

		if ($message.length && ! window.crawler) {
			const format = scope.criteria.format;
			const sale = format === 'sale';

			let shareable = $message.data('shareable');

			const options = {
				placeholder: 'I\'m interested in this ' + (sale ? 'property' : format),
				target: 'listing',
				id: scope.id,
				context: {
					key: scope.context.key,
					source: scope.context.source
				},
				transform: data => {
					if (shareable) {
						data.share = data.share || '0';

						LS.store.set('shareable', data.share === '1');
					}

					if ($message.data('referable')) {
						data.refer = '1';
					}
				}
			};

			if ($.context('status') === 'pending') {
				options.gate = {
					message: 'This property is under contract but may be accepting backup offers.'
				};
			} else {
				const price = scope.criteria.price;

				if (! sale || (price && (price <= 100 || price >= 2000000))) {
					options.required = true;
				} else {
					const loc = LS.user.location(true) || {};

					if (! loc.slug || loc.risk > 1) {
						options.required = true;
					}
				}
			}

			scope.message = Apt.fn.message()
				.init(options);

			if (shareable) {
				shareable = false;

				LS.util.scrolled($message, 'property', () => {
					LS.api.get(`listings/${scope.id}/referable`, {
						namespace: 'listing',
						success: data => {
							if (data.match) {
								$$('messageFields').html(
									$.view.render('property._connect', {
										checked: LS.store.get('shareable', true)
									})
								);

								$$('messageConnect').on('click', () => {
									LS.util.view('property', 'connect', template => {
										LS.modal.open({
											model: {
												title: "Partner with an agent",
												content: template
											},
											width: 520
										});
									});
								}, {
									namespace: 'property'
								});
							}
						}
					});
				}, {
					margin: 360
				});
			}

			$$('messageModal').on('click', () => {
				LS.util.view('property', 'rules', template => {
					LS.modal.open({
						model: {
							title: 'Message rules',
							content: template
						},
						width: 520
					});
				});
			}, {
				namespace: 'property'
			});

			$$('messageContact').on('click', () => {
				LS.util.view('property', 'contact', template => {
					LS.modal.open({
						model: {
							title: 'Real estate professionals',
							content: template
						},
						width: 520
					});
				});
			}, {
				namespace: 'property'
			});
		}

		$$('profileLink', '$agents').on('click', (e, el) => {
			LS.analytics.track({
				action: 'click',
				target: 'listing',
				id: scope.id,
				category: 'profile',
				attributes: {
					id: $(el).closest('[data-user-id]')
						.data('id')
				}
			});
		}, {
			namespace: 'property'
		});
	},

	/**
	 * Initialize truncation
	 */
	initTruncate() {
		this.truncate = $$('truncate').map(el => Apt.fn.truncate()
			.init(el));
	},

	/**
	 * Initialize data
	 */
	initData() {
		const scope = this;

		$$('propertyExpand').on('click', (e, el) => {
			const $target = $('[data-type="' + el.dataset.target + '"]');

			$target[0].open = true;

			LS.util.setScroll($target, false);

			$target.trigger('click');
		}, {
			namespace: 'property'
		});

		$$('propertySection').on('click', (e, el) => {
			const type = el.dataset.type;

			if (type === 'payment') {
				scope.initPayment();
			}

			LS.analytics.interact('listing', 'expand', type);
		}, {
			namespace: 'property'
		});
	},


	/**
	 * Initialize payment
	 */
	initPayment() {
		const scope = this;

		if (! scope.payment) {
			LS.util.load('payment', () => {
				if (! scope.id) {
					return;
				}

				scope.payment = Apt.fn.payment()
					.init('$propertyPayment', $.context('payment', {}));
			});
		}
	},

	/**
	 * Initialize state
	 */
	initState() {
		const scope = this;
		const activeClass = '-is-active';
		const events = {
			saves: 'Save',
			hidden: 'Hide'
		};

		for (const [type, value] of Object.entries(events)) {
			const $target = $$('property' + value);
			const on = () => $target.addClass(activeClass);
			const off = () => $target.removeClass(activeClass);

			$.observe('user', () => {
				const module = LS.user.get(type);

				if (module) {
					const exists = type === 'saves' ?
						module[scope.id] :
						module.includes(scope.id);

					exists ?
						on() : off();
				}
			}, {
				init: true,
				namespace: 'property',
				recursive: true
			});

			$target.on('click', () => {
				LS.user.guard(() => {
					const state = Apt['properties.state'];

					if ($target[0].classList.contains(activeClass)) {
						state.remove(type, scope.id, null, {
							success: off
						});
					} else {
						state.add(type, scope.id, scope.context, {
							success: on
						});
					}
				});
			}, {
				namespace: 'property'
			});
		}
	},

	/**
	 * Initialize copy
	 */
	initCopy() {
		LS.util.copy('$propertyCopy', 'Property', {
			delegate: '$detail',
			namespace: 'property'
		});
	},

	/**
	 * Initialize the property event tracking
	 */
	initAnalytics() {
		const scope = this;
		const context = {
			key: scope.context.key,
			source: scope.context.source
		};

		LS.analytics.track({
			action: 'view',
			target: 'listing',
			id: scope.id,
			category: 'entry'
		}, context);

		scope.call = Apt.fn.call()
			.init({
				target: 'listing',
				id: scope.id,
				context: context
			});

		$$('propertyLink').on('click', (e, el) => {
			const id = el.dataset.id;
			const type = el.dataset.type;
			const event = {
				action: 'click',
				target: 'listing',
				id: scope.id,
				category: 'link',
				segment: type
			};

			if (id) {
				event.attributes = {
					id: Number(id)
				};
			}

			LS.analytics.track(event, context);

			if (type === 'source') {
				window.open($.context('source'), '_blank');
			}
		}, {
			namespace: 'property'
		});
	},

	/**
	 * Initialize ads
	 */
	initAds() {
		if ($.context('ads') === false) {
			return;
		}

		let scope = this;

		LS.util.load('ads', () => {
			if (! scope.id) {
				return;
			}

			scope.ads = Apt.fn.ads().init({
				margin: () => $.screen.size() < 4 ?
					480 : 380,
				targeting: () => ({
					section: 'property'
				}),
				units: () => $('[data-unit]', '$detail'),
				empty: $ad => {
					if (! $ad.visible(0.3)) {
						$ad.remove();

						return;
					}

					LS.util.view('ads', 'agents', template => {
						$ad.html(template)
					});
				}
			});
		});
	},

	/**
	 * Initialize featured agent
	 */
	initAgent() {
		const scope = this;
		const $agent = $$('propertyAgent');

		if (! $agent.length) {
			return;
		}

		LS.util.scrolled($agent, 'property', () => {
			LS.profiles.feature($agent, scope.criteria);
		}, {
			margin: 540
		});
	},

	/**
	 * Initialize relevant properties
	 *
	 * @param {Number} id
	 */
	initRelevant(id) {
		const scope = this;
		const $relevant = $$('propertyRelevant');
		const promoted = $.context('promoted');
		const params = {
			exclude: id,
			near: scope.context.center,
			limit: 4,
			random: true
		};

		if (promoted) {
			params.agent_id = $$('agents').data('values'); // eslint-disable-line
		} else {
			params.context = scope.criteria;
		}

		LS.util.scrolled($relevant, 'property', () => {
			scope.relevant = Apt.fn['properties.relevant']().init({
				context: $relevant,
				params: params,
				paginate: promoted,
				updated: data => {
					if (! data.results.length) {
						$relevant.hide();
					}
				}
			}, null);
		}, {
			margin: 680
		});
	},

	/**
	 * Initialize embed behavior
	 *
	 * @param {String} source
	 */
	initEmbed(source) {
		const scope = this;

		if (scope[source]) {
			return;
		}

		const urls = {
			acres: 'https://www.acres.com/embed?savedId={{id}}&layers=soil,crop,elevation',
			mapright: 'https://id.land/ranching/maps/{{id}}/embed/',
			matterport: 'https://my.matterport.com/show/?m={{id}}&brand=0&mls=2&nt=1&play=1&search=0&vr=0'
		};

		scope[source] = $.app.media.$get(['key', {
			'embeds.source': source
		}]);

		$$(source + 'Media').html(
			'<iframe src="' + urls[source].replace('{{id}}', scope[source]) + '" allowfullscreen>'
		);
	},

	/**
	 * Show property map
	 */
	showMap() {
		const scope = this;

		if (scope.map) {
			scope.map.resize();

			return;
		}

		LS.analytics.track({
			action: 'click',
			target: 'listing',
			id: scope.id,
			category: 'map'
		}, {
			key: scope.context.key,
			source: scope.context.source
		});

		scope.$map = $('<div class="map -is-loading"/>');

		scope.$map.appendTo('$mapMedia');

		LS.util.load('maps', () => {
			if (! scope.id) {
				return;
			}

			scope.createMap();
		});
	},

	/**
	 * Create new map instance
	 */
	createMap() {
		const scope = this;
		const precision = scope.context.precision;
		const low = precision === 'low';

		let zoom;

		if (precision === 'low') {
			zoom = 13;
		} else if (precision === 'medium') {
			zoom = 14;
		}

		scope.map = Apt.fn.maps().init(scope.$map[0], {
			center: scope.context.center,
			single: low ?
				'hide' : true,
			toggle: false,
			polygons: scope.context.geometry || null,
			model: precision !== 'high' ? {
				warning: 'Estimated location'
			} : null,
			settings: {
				center: scope.context.center,
				zoom: zoom || scope.getZoom()
			}
		});
	},

	/**
	 * Get initial map zoom level
	 *
	 * @returns {Number}
	 */
	getZoom() {
		const size = this.criteria.size || 5;

		if (size > 10) {
			return 14.6;
		}

		if (size < 2) {
			return 16.5;
		}

		return 15.5;
	},

	/**
	 * Lazy initialize sharing
	 *
	 * @param {Object} context
	 * @param {String} namespace
	 * @param {Object} options
	 */
	initShare(context, namespace, options) {
		const scope = this;

		$$('propertyShare').on('click', () => {
			if (context.share) {
				context.share.show();

				return;
			}

			LS.util.load('share', () => {
				if (! scope.id) {
					return;
				}

				context.share = Apt.fn.share()
					.init(options);

				context.share.show();
			});
		}, {
			cancel: true,
			namespace: namespace
		});
	},

	/**
	 * Initialize mobile options
	 */
	initOptions() {
		const $target = $$('propertySeller');
		const options = {
			namespace: 'property',
			once: true
		};

		$$('propertyContact').on('click', () => {
			LS.util.setScroll($target);
		}, options);

		$.scroll.map([
			{
				target: $$('media'),
				threshold: -1,
				callback: () => {
					$$('propertyOptions').addClass('-is-visible');
				}
			},
			{
				target: $target,
				callback: () => {
					$$('propertyOptions').hide();
				}
			}
		], options);
	}
});